// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : stats templates
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Label, Statistic, Loader, Icon} from 'semantic-ui-react'
//~ import jpath from 'jsonpath'

// ---Framework imports
import {Sel, Actions} from 'uix/registries'
import log from 'uix/logging'
import {
  keys,
  dict,
  flatten,
  isString,
  filterItems,
  get,
  items,
  uniq,
  isNumber,
  isInteger,
} from 'ldash'

import {formatNumber} from 'uix/i18n'
import {useSelector, useEffect, useState, useSummaries} from 'uix/hooks'

// ---Local imports

// ---Exports
const ScalarStat = ({value, label, size, floated, icon, language}) => {
  let props = {size}
  if (floated) {
    props.floated = floated
  }

  value = formatNumber(value, language)

  //XXX: maybe make the spacing between icon and value configurable
  if (icon) {
    return (
      <Statistic {...props}>
        <Statistic.Value>
          <Icon name={icon} /> {value}
        </Statistic.Value>
        <Statistic.Label>{label}</Statistic.Label>
      </Statistic>
    )
  }
  return <Statistic value={value} label={label} {...props} />
}

const Stat = ({get: query, label, icon = null, floated = false, size}) => {
  let i18n = useSelector(Sel.i18n)
  let stats = useSelector(Sel.statistics)

  //~ jpath.query()
  if (!stats || !query) {
    return <Loader size={size} active inline />
  }

  let [table, row, column] = query.split('.')

  let props = {size, floated, icon, language: i18n._language}

  if (table && (row == '*' || !column)) {
    let data = null
    if (!column) {
      data = get(stats, `${table}.${row}`, {})
    } else {
    }
    let rowStats = filterItems(data, (k, v) => true).map(([label, value]) => (
      <ScalarStat key={label} value={value} label={i18n.get(label)} {...props} />
    ))
    return <Statistic.Group size={size}>{rowStats}</Statistic.Group>
  } else {
    let value = get(stats, `${table}.${row}.${column}`, 0)
    return ScalarStat({value, label, ...props})
  }
}

const StatisticFetcher = ({elements, dname}) => {
  let getTable = query => query && query.split('.')[0]
  let neededSummaries = uniq(elements.map(e => getTable(e.attrib.get)).filter(e => e))
  useSummaries(neededSummaries, dname)
  return null
}

export const statistic = {
  match: ({tag}) => tag == 'Statistic',
  build: ({attrib}) => <Stat {...attrib}>123</Stat>,
  completion: ({}) => {
    return {
      '!top': ['Statistic'],
      Statistic: {
        attrs: {
          get: ['domain.', 'datatype.', 'metadata.'],
          floated: ['left', 'right'],
          icon: ['play'],
          size: ['mini', 'tiny', 'small', 'large', 'huge'],
        },
      },
    }
  },
  init: ({keys, ddata}) =>
    keys.byTag['Statistic'] && (
      <StatisticFetcher dname={ddata.name} elements={keys.byTag['Statistic']} />
    ),
}
